import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "ModalModifierProdCondMagInv",
  tabindex: "-1",
  role: "dialog",
  ref: "addModalModifierProdCondMagInvRef",
  "aria-labelledby": "tooltipmodal",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title",
  style: {"font-size":"11px"}
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12 mb-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-12 mb-3" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-12 mb-3" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col-md-12 mb-3" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "modal-title" }, "Modification de l'inventaire", -1)),
          (_ctx.item)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_5, _toDisplayString(_ctx.item.nomProd), 1))
            : _createCommentVNode("", true),
          _cache[5] || (_cache[5] = _createElementVNode("button", {
            class: "btn-close py-0",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.item)
            ? (_openBlock(), _createBlock(_component_Form, {
                key: 0,
                ref: "modifierProdCondMagInvForm",
                onSubmit: _ctx.editModalModifierProdCondMagInv,
                "validation-schema": _ctx.modifierProdCondMagInvSchema
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Id "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.item.id,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.id) = $event)),
                          name: "id",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Id"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "id",
                          class: "text-danger"
                        })
                      ])
                    ], 512), [
                      [_vShow, false]
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Stock Fiche "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.item.qteFiche,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.qteFiche) = $event)),
                          name: "qteFiche",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "XX"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "qteFiche",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Stock Logique "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.item.qteLogique,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.qteLogique) = $event)),
                          name: "qteLogique",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "XX"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "qteLogique",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Observation "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.item.observation,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.observation) = $event)),
                          name: "observation",
                          type: "textarea",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Une observation ?"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "observation",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("button", {
                      class: "btn btn-primary",
                      type: "submit"
                    }, " Appliqué ", -1))
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}